module.exports = __webpack_public_path__ + "img/frown.29c50764.svg";